import { Record } from 'immutable';
import { ASSIGNMENT_REMOVAL } from '../constants/overlayTypes';
const AssignmentRemovalOverlay = Record({
  assignee: null,
  initiatingAgent: null,
  type: ASSIGNMENT_REMOVAL
}, 'AssignmentRemovalOverlay');
export default AssignmentRemovalOverlay;